import PhoneVerification from './PhoneVerification';

export default PhoneVerification;
